import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {AuthenticationService} from '../../authentication/authentication.service';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss']
})
export class ErrorModalComponent {

  @ViewChild('errorMessage')
  private errorMessageContainer: ElementRef;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private authenticationService: AuthenticationService) {
  }

  getErrorMailUrl() {
    return 'mailto:plattform-support@drklein.de﻿?subject=Fehler in Überleitungstool 2.0&body=' + encodeURIComponent(
      'Es ist ein Fehler in dem Überleitungstool 2.0 aufgetreten: \n\n'
      + 'Link zum Tool: ' + window.location.href + '\n\n'
      + 'Fehlerbericht: \n----------------------------------------------------------\n'
      + JSON.stringify(this.data) + '\n'
      + 'user: ' + this.authenticationService.getUsername()
      + '\n\n');
  }

  reload() {
    window.location.reload();
  }
}
